// extracted by mini-css-extract-plugin
module.exports = {"image":"image_image__EDBQE","root":"image_root__lO5rb"};